import { sanitizeHtml, escapeHtml } from './sanitize.js';

/**
 * Très petit parser markdown : **gras**, *italique*, listes, liens.
 * Tout est rendu en HTML escaped puis re-injecté dans des tags whitelistés,
 * pour que sanitize.ts puisse vérifier le résultat.
 */
export function renderMarkdown(input: string): string {
  if (!input) return '';
  let html = escapeHtml(input);

  // Bold **text**
  html = html.replace(/\*\*([^*\n]+)\*\*/g, '<strong>$1</strong>');
  // Italic *text* (single asterisk, not bold)
  html = html.replace(/(^|[^*])\*([^*\n]+)\*(?!\*)/g, '$1<em>$2</em>');

  // Inline links [text](url)
  html = html.replace(/\[([^\]]+)\]\(([^)\s]+)\)/g, (_, text, url) => {
    const safeUrl = url.replace(/&amp;/g, '&');
    return `<a href="${safeUrl}">${text}</a>`;
  });

  // Lists: lines starting with "- " or "1. "
  const lines = html.split(/\n/);
  const out: string[] = [];
  let listType: 'ul' | 'ol' | null = null;
  for (const line of lines) {
    const ulMatch = /^[-*]\s+(.+)$/.exec(line);
    const olMatch = /^\d+\.\s+(.+)$/.exec(line);
    if (ulMatch) {
      if (listType !== 'ul') {
        if (listType) out.push(`</${listType}>`);
        out.push('<ul>');
        listType = 'ul';
      }
      out.push(`<li>${ulMatch[1]}</li>`);
    } else if (olMatch) {
      if (listType !== 'ol') {
        if (listType) out.push(`</${listType}>`);
        out.push('<ol>');
        listType = 'ol';
      }
      out.push(`<li>${olMatch[1]}</li>`);
    } else {
      if (listType) {
        out.push(`</${listType}>`);
        listType = null;
      }
      out.push(line);
    }
  }
  if (listType) out.push(`</${listType}>`);

  // Paragraph break on double newline
  let combined = out.join('\n').replace(/\n{2,}/g, '<br><br>').replace(/\n/g, '<br>');

  return sanitizeHtml(combined);
}
